// Library Methods
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";
import { useSnackbarContext } from "src/contexts/alerts/SnackbarContext";

// Types and API
import { addClinicVideo } from "../../api";

export const useAddClinicVideo = (clinicId: string | undefined) => {
  const queryClient = useQueryClient();
  const { getToken } = useTokenAccess();
  const { t } = useTranslation();
  const { setSnackbarInfo } = useSnackbarContext();

  return useMutation({
    mutationFn: async (videoData: any) => {
      if (!clinicId) throw new Error();

      try {
        const token = await getToken();
        return addClinicVideo(token, clinicId, {
          // versionNum: "1",
          // videoName: "another test",
          // videoUrl: "https://www.youtube.com/watch?v=UG4b_4mJz9Y",
        });
      } catch (error) {
        throw error;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["clinic-videos", clinicId],
      });
      setSnackbarInfo({
        variant: "success",
        message: t("Video added successfully!"),
      });
    },
    onError: () => {
      setSnackbarInfo({
        variant: "error",
        message: t("Video could not be added!"),
      });
    },
  });
};
